module.exports = __webpack_public_path__ + "media/images/about/b4@2x-5494c9a4cd1e05831ec001483d30186e.png";